/** Browser / platform detection for PWA install tutorial (kitchen). */

export const isIosUserAgent = () => {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isIosPlatform = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return true;
  return /\bMacintosh\b/i.test(ua) && navigator.maxTouchPoints > 1;
};

export const isIpadIos = () => {
  if (!isIosPlatform()) return false;
  const ua = navigator.userAgent || '';
  if (/iPad/i.test(ua)) return true;
  return /\bMacintosh\b/i.test(ua) && navigator.maxTouchPoints > 1;
};

export const isIphoneIos = () => isIosPlatform() && !isIpadIos();

const readClientHintBrands = () => {
  try {
    return navigator.userAgentData?.brands?.map((brand) => brand.brand) ?? [];
  } catch {
    return [];
  }
};

const detectIosBrowser = (ua) => {
  if (/CriOS/i.test(ua)) return 'chrome-ios';
  if (/FxiOS/i.test(ua)) return 'firefox-ios';
  if (/EdgiOS/i.test(ua)) return 'edge-ios';
  if (/OPiOS/i.test(ua)) return 'opera-ios';

  const brands = readClientHintBrands();
  if (brands.some((brand) => /Google Chrome/i.test(brand))) return 'chrome-ios';
  if (brands.some((brand) => /Microsoft Edge/i.test(brand))) return 'edge-ios';

  const vendor = navigator.vendor || '';
  if (/Google/i.test(vendor)) return 'chrome-ios';

  if (/Version\//i.test(ua)) return 'safari-ios';

  return 'ios-unknown';
};

export const detectWebBrowser = () => {
  const ua = navigator.userAgent || '';

  if (/CriOS/i.test(ua)) return 'chrome-ios';
  if (/FxiOS/i.test(ua)) return 'firefox-ios';
  if (/EdgiOS/i.test(ua)) return 'edge-ios';
  if (/OPiOS/i.test(ua)) return 'opera-ios';

  if (isIosPlatform()) {
    return detectIosBrowser(ua);
  }

  if (/Android/i.test(ua) && /SamsungBrowser/i.test(ua)) return 'samsung-android';
  if (/Android/i.test(ua) && /Firefox/i.test(ua)) return 'firefox-android';
  if (/Android/i.test(ua) && /Chrome/i.test(ua)) return 'chrome-android';
  if (/Firefox/i.test(ua)) return 'firefox';
  return 'other';
};
